
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
    'en-US': {
        translation: require('./lang/en-US.json'),
    },
    'en-NZ': {
        translation: require('./lang/en-NZ.json'),
    },
    'es': {
        translation: require('./lang/es.json'),
    },
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'en-US',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
